import React from 'react';

import logo from '/logo.svg';
import styles from './styles.module.scss';

const FOOTER_NAV = [
  {
    name: 'Contact',
    href: 'https://www.agriculture.gov.au/about/contact',
  },
  {
    name: 'Accessibility',
    href: 'https://www.agriculture.gov.au/about/commitment/accessibility',
  },
  {
    name: 'Disclaimer',
    href: 'https://www.agriculture.gov.au/about/disclaimer',
  },
  {
    name: 'Privacy',
    href: 'https://www.agriculture.gov.au/about/commitment/privacy',
  },
  {
    name: 'FOI',
    href: 'https://www.agriculture.gov.au/about/reporting/freedom-of-information',
  },
];

export const Layout = ({ children }: React.PropsWithChildren) => (
  <main className={styles.main}>
    <header className={styles.header}>
      <div className={styles.wrapper}>
        <img
          src={logo}
          className={styles.logo}
          alt="Australian Government - Department of Agriculture, Fisheries and Forestry"
        />
      </div>
    </header>
    <article className={styles.content}>
      <div className={styles.wrapper}>{children}</div>
    </article>
    <footer className={styles.footer}>
      <div className={styles.wrapper}>
        <ul className={styles.footernav}>
          {FOOTER_NAV.map(({ name, href }) => (
            <li key={name}>
              <a href={href}>{name}</a>
            </li>
          ))}
        </ul>
        <a href="https://www.agriculture.gov.au/about/copyright">
          © Department of Agriculture, Fisheries and Forestry
        </a>
      </div>
    </footer>
  </main>
);
